import { render } from "./GlobalError.vue?vue&type=template&id=0a4ae6ba&ts=true"
import script from "./GlobalError.vue?vue&type=script&lang=ts"
export * from "./GlobalError.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__